import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layout bileşenleri
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/utility/ScrollToTop';

// Sayfa bileşenleri
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import WhyUs from './pages/WhyUs';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/hizmetler" element={<Services />} />
            <Route path="/neden-biz" element={<WhyUs />} />
            <Route path="/iletisim" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 